
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/hooks/useAuth";
import { discoveryService, SortingType } from "@/services/discoveryService";

interface FilterState {
  ageMin: number;
  ageMax: number;
  maxDistance: number;
  onlineOnly: boolean;
  withPhotoOnly: boolean;
  lookingFor: string[];
}

type RibbonToSortingMap = {
  nearby: "nearby";
  activity: "activity";
  discovery: "nearby"; // Discovery uses nearby sorting but could be enhanced later
  buzzz: "most_buzzz";
};

export const useProfileCache = (filters: FilterState, profileLimit: number, subscriptionTier: string, ribbonType: "activity" | "nearby" | "discovery" | "buzzz" = "nearby") => {
  const { user } = useAuth();

  // Map ribbon types to sorting types
  const ribbonToSorting: RibbonToSortingMap = {
    nearby: "nearby",
    activity: "activity", 
    discovery: "nearby", // For now, discovery uses nearby sorting
    buzzz: "most_buzzz"
  };

  const sortBy: SortingType = ribbonToSorting[ribbonType];

  console.log('🎯 useProfileCache called with:', {
    ribbonType,
    sortBy,
    profileLimit,
    subscriptionTier,
    userId: user?.id
  });

  const { data: nearbyUsers, isLoading, refetch } = useQuery({
    queryKey: ['nearby-users', filters, user?.id, subscriptionTier, sortBy],
    queryFn: () => discoveryService.fetchNearbyUsers(
      user?.id || '',
      filters,
      profileLimit,
      subscriptionTier,
      sortBy
    ),
    enabled: !!user
  });

  const handleRefresh = async () => {
    if (user) {
      await discoveryService.clearCache(user.id);
    }
    refetch();
  };

  return {
    nearbyUsers,
    isLoading,
    handleRefresh
  };
};
